import React, { useEffect, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { getFinacInternalUsersAction } from "../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { UserListType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import useDebounce from "../../../customHooks/useDebounce";
import { components } from "react-select";
import { CircularAvatar } from "..";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";
export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
type AppProps = {
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  internalUsersList: any;
  internalUserCount: string | number;
  internalUserSelected: DropDownType;
  setInternalUserSelected: (data: DropDownType) => void;
  dispatchGetFinacInternalUsersAction: (
    data: GetAllFinacUserPayloadType
  ) => void;
  type?:string;
};
const InternalUsersDropdown = ({
  token,
  fetching,
  success,
  error,
  statusCode,
  internalUsersList,
  internalUserCount,
  internalUserSelected,
  setInternalUserSelected,
  dispatchGetFinacInternalUsersAction,
  type
}: AppProps) => {
  const [finalInternalUserList, setFinalInternalUserList] = useState<
    DropDownType[] | []
  >([]);
  const [loadCondition, setLoadCondition] = useState(true);

  const [clearInternalSearchText, setClearInternalSearchText] = useState(false);
  const [internalText, setInternalText] = useState("");
  const [internalOffset, setInternalOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (token) {
      if (internalOffset <= +internalUserCount) {
        let finalInternalUserData = {
          token,
          status: 1,
          user_type: "stco_users",
          offset: internalOffset,
          limit,
          search_term: internalText,
        };
        dispatchGetFinacInternalUsersAction(finalInternalUserData);
      }
    }
  }, [internalOffset]);

  useEffect(() => {
    if (clearInternalSearchText) {
      const finalData = {
        token,
        offset: internalOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: internalText,
      };
      if (internalText?.length === 0) {
        dispatchGetFinacInternalUsersAction(finalData);
        setInternalOffset(0);
      }
    }
  }, [clearInternalSearchText, internalText]);

  useEffect(() => {
    if (internalUsersList?.length > 0) {
      if (internalOffset <= +internalUserCount) {
        let finalUserData = internalUsersList?.map((user: any) => {
          return {
            value: user?.user_id,
            label: `${user?.first_name ? user?.first_name : ""} ${
              user?.last_name ? user?.last_name : ""
            }%${user?.job_title ? user?.job_title : ""} ${
              user?.department ? "|" : ""
            } ${user?.department !== null ? user?.department : ""}`,
            image: user?.profile_pic?.file_url,
          };
        });

        if (internalOffset > 0) {
          setFinalInternalUserList([
            ...finalInternalUserList,
            ...finalUserData,
          ]);
        } else {
          setFinalInternalUserList([...finalUserData]);
        }
      }
    }
  }, [internalUsersList]);

  const fetchInternalNewData = (search: string) => {
    setClearInternalSearchText(true);
    const finalData = {
      token,
      offset: internalOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: internalText,
    };
    if (internalOffset === 0) {
      dispatchGetFinacInternalUsersAction(finalData);
    } else {
      setInternalOffset(0);
    }
  };

  useDebounce(
    () => {
      if (internalText) {
        fetchInternalNewData(internalText);
      }
    },
    500,
    [internalText]
  );

  const handleChangeInternalUser = (user: any) => {
    setSearchValue("");
    setInternalUserSelected({
      value: user?.value,
      label: user?.label?.split("%")[0],
    });
  };

  const checkBottomInternal = (e: any) => {
    setLoadCondition(false);
    setInternalOffset((prv) => prv + limit);
  };

  const onMenuClose = () => {
    setLoadCondition(true);
    setInternalOffset(0);
  };


  const Option = (props: any) => {
    const { data, selectProps } = props;
      const isSelectOption = data?.label === "Select..";
  
    if (!isSelectOption) {
      return (
        <components.Option {...props}>
          <div
            className="d-flex justify-content-sm-start"
            style={{ gap: "10px" }}
          >
            <CircularAvatar
              name={data?.label?.split("%")[0]}
              image={data?.image && data?.image}
            />
            <div style={{ marginTop: "-3px" }}>
              <span style={{ fontWeight: "500", fontSize: "16px" }}>
                {data?.label?.split("%")[0]}
              </span>
              <br></br>
              <span style={{ color: "#6e7491" }}>
                {data?.label?.split("%")[1]}
              </span>
            </div>
          </div>
        </components.Option>
      );
    } else {
      return (
        <components.Option {...props}>
          <span style={{ fontWeight: "500", fontSize: "16px" ,marginLeft:'17px'}}>
            {data.label}
          </span>
        </components.Option>
      );
    }
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: '300px',
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: '50%',
    }),
    container: (provided: any) => ({
      ...provided,
      width: 320,
      position: 'absolute'
    })
  }

  return (
    <div className="d-flex align-items-start row">
      <div className="col-md-12">
        <label className="mb-1">Select User</label>
        <Select
          value={internalUserSelected}
          cacheOptions
          options={type=='timesheetSchedulingReport'?finalInternalUserList?.length > 0
            ? [
                { label: "Select..", value: null },
                ...finalInternalUserList,
              ]
            : []:finalInternalUserList}
          components={{ Option }}
          onChange={handleChangeInternalUser}
          onMenuScrollToBottom={(e: any) => checkBottomInternal(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setInternalText(e);
          }}
          onMenuClose={onMenuClose}
          isLoading={fetching}
          styles={
            type === 'timesheetSchedulingReport' ? dropDownStyle : undefined
          }

        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.auth.internalFetching,
  statusCode: state.auth.statusCode,
  success: state.auth.success,
  error: state.auth.error,
  internalUsersList: state.auth.internalUsersList,
  internalUserCount: state.auth.internalUserCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetFinacInternalUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getFinacInternalUsersAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalUsersDropdown);
